import {makeAutoObservable} from "mobx";
import CsInstance from "./CsInstance";

/**
 * This store is used to manage the single global modal.  There should be no
 * other modals except for the method manifest (a special case that only covers
 * the IDE).
 */
export class GlobalModalStore {
	private _isOpen = false;
	private _modalContent: React.ReactElement | null = null;

	constructor(props: {csInstance: CsInstance}) {
		makeAutoObservable(this);
	}

	/**
	 * Shows the global modal, with the given content.
	 * @param newContent replaces whatever content was in the global modal previously
	 */
	showModal(newContent: React.ReactElement) {
		this._modalContent = newContent;
		this._isOpen = true;
	}

	closeModal() {
		this._isOpen = false;
		this._modalContent = null; // just in case
	}

	get isOpen() {
		return this._isOpen;
	}

	get modalContent() {
		return this._modalContent;
	}
}

export default GlobalModalStore;
